import React, { Component } from 'react';

export default class extends Component {
  constructor(props) {
      super(props);

  }

  render() {
    return (
      <div className="row" style={{marginBottom:"20px"}}>
        <div className="small-1 medium-1 centered-text">
          <img className="full-width" src="/images/check.png" style={{maxWidth:'35px'}} />
        </div>
        <div className="small-11 medium-11 row">
          <div className="full-width subheading" style={{paddingLeft:"10px",margin:"auto"}}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/checkmarkRow/index.js